module.exports = __webpack_public_path__ + "img/DW365-025.69920384.jpg";